import { POST_INFO_APPLY_ERROR, POST_INFO_APPLY_START, POST_INFO_APPLY_SUCCESS } from '../../types';

export default function post_info_apply(state, action) {
  switch (action.type) {
    case POST_INFO_APPLY_START:
      return { ...state };
    case POST_INFO_APPLY_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case POST_INFO_APPLY_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}